<tt-form-field-base
    [ttRememberId]="ttRememberId"
    [ttRememberDebounceTime]="ttRememberDebounceTime"
    [ttFieldId]="id.checkbox"
    [ttLabel]="ttLabel"
    [ttLabelView]="ttLabelView"
    [ttTranslateLabel]="ttTranslateLabel"
    [ttSublabel]="ttSublabel"
    [ttTranslateSublabel]="ttTranslateSublabel"
    [ttToggleTipText]="ttToggleTipText"
    [ttTranslateToggleTipText]="ttTranslateToggleTipText"
    [ttInvalid]="ttInvalid"
    [ttInvalidText]="ttInvalidText"
    [ttTranslateInvalidText]="ttTranslateInvalidText"
    [ttRequired]="ttRequired"
    [ttReadonly]="ttReadonly"
    [ttDisabled]="ttDisabled"
    [ttStyle]="ttStyle"
    ttInputType="checkbox"
>
    <input
        #checkboxRef
        class="tt-input__form-control tt-input__form-control--checkbox"
        type="checkbox"
        [ngModel]="_model"
        (click)="onReadonlyInteraction($event)"
        (keydown.space)="onReadonlyInteraction($event)"
        (ngModelChange)="onModelChange($event)"
        (blur)="onBlur()"
        [attr.name]="id.checkbox"
        [attr.id]="id.checkbox"
        [attr.readonly]="ttReadonly ? true : null"
        [attr.aria-readonly]="ttReadonly"
        [readOnly]="ttReadonly"
        [disabled]="ttDisabled"
        [ngStyle]="style['checkbox']"
    />
</tt-form-field-base>
